import { ObjectTools } from '../../tools/object-tools';
import { SolText } from './sol-text';

export type SolTooltipPosition = 'top' | 'bottom' | 'left' | 'right';

export class SolTooltip {
  private constructor(
    public readonly text: SolText,
    public readonly position: SolTooltipPosition,
    public readonly custom: boolean,
    public readonly wide: boolean,
  ) {}

  public static of(text: SolText): SolTooltip {
    return new SolTooltip(text, 'bottom', false, false);
  }

  public static ofCustom(): SolTooltip {
    return new SolTooltip(SolText.empty(), 'bottom', true, false);
  }

  public withPosition(position: SolTooltipPosition): SolTooltip {
    if (this.position === position) return this;
    return this.copy({ position });
  }

  public withWide(): SolTooltip {
    if (this.wide) return this;
    return this.copy({ wide: true });
  }

  private copy(props: Partial<SolTooltip>): SolTooltip {
    return ObjectTools.copy<SolTooltip>(this, props);
  }
}
